import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import {sanitizeContent} from 'js/shared/security';

import styles from './ReinsuranceBanner.module.scss';

const cx = classnames.bind(styles);

const ReinsuranceBanner = ({
  className,
  data,
  data: {
    backgroundColor = '#FFCBD1',
    textColor = '#000000',
    leftItemIcon,
    leftItemTitle,
    leftItemText,
    rightItemIcon,
    rightItemTitle,
    rightItemText,
  },
}) => {
  const sections = [{
    icon: leftItemIcon,
    title: leftItemTitle,
    text: leftItemText,
  }, {
    icon: rightItemIcon,
    title: rightItemTitle,
    text: rightItemText,
  }];

  const bannerStyles = {
    backgroundColor,
    color: textColor
  }

  return (
    <div style={bannerStyles} className={cx('root', className)}>
      {sections.map((section, i) => (
        <div key={i} className={cx('section')}>
          {section.icon && (<i aria-hidden={true} className={cx('img', section.icon)}/>)}
          {section.title && (<p className={cx('title')}><strong>{section.title}</strong></p>)}
          {section.text && (
            <div className={cx('description')} dangerouslySetInnerHTML={{
              __html: sanitizeContent(section.text)
            }}/>
          )}
        </div>
      ))}
    </div>
  )
}

ReinsuranceBanner.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    backgroundColor: PropTypes.string,
    leftItemIcon: PropTypes.string,
    leftItemText: PropTypes.string,
    leftItemTitle: PropTypes.string,
    rightItemIcon: PropTypes.string,
    rightItemText: PropTypes.string,
    rightItemTitle: PropTypes.string,
    textColor: PropTypes.string,
  }).isRequired
}

export default ReinsuranceBanner;
